import { render, staticRenderFns } from "./SquareCricle.vue?vue&type=template&id=e9352b24&"
import script from "./SquareCricle.vue?vue&type=script&lang=js&"
export * from "./SquareCricle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports